import React,{ Fragment } from 'react';
import PropTypes from 'prop-types';
import CelaneseAPI from '../../services';
import './createPlugwrap.css';
import { Combobox } from 'react-widgets';
import 'react-widgets/dist/css/react-widgets.css';
import { InputNumber, Form, Input, message } from 'antd';
import { getPlugwrapData } from './../../actions/index';
import { connect } from 'react-redux';
import config, { utils } from '../../config';
import Translation from '../../Translation';

const FormItem = Form.Item;

/**
 * Class for create plugwrap.
 *
 * @class CreatePlugwrap
 * @extends {React.Component}
 */
class CreatePlugwrap extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            manufacturer: '',
            wrapType: '',
            corpor: 0,
            thick: 0,
            weight: 0,
            plugwrapData: []
        };

        this.handleFilter = this.handleFilter.bind(this);
        this.clearFields = this.clearFields.bind(this);
    }

    /**
     * clearFields function is for clearing the fields on the form
     * 
     * @memberof CreatePlugwrap
     */
    clearFields() {
        this.setState({
            name: ''
        });
                this.props.form.setFieldsValue({
                    manufacturer: '',
                    wrapType: '',
                    corpor: 0,
                    thick: 0,
                    weight: 0
                });
    }

    componentWillMount() {
        this.assignData(this.props);
    }
    componentWillReceiveProps(nextProps) {
        this.assignData(nextProps);
    }

    /**
     * assignData function is for getting the plugwrap data from redux/store
     * @param {object|array} nextProps
     * @memberof CreatePlugwrap
     */
    assignData(nextProps) {
        if(nextProps.plugwrapData) {
            this.setState({
                plugwrapData: nextProps.plugwrapData
            });
        }
    }

    /**
     * success function shows a success message when plugwrap is created/updated successfully
     * 
     * @memberof CreatePlugwrap
     */
    success = () => {
        message.success(utils.getTranslationText ('msg_plugwrap_successfully_created','Plugwrap successfully created'), 2);
    };
      
    /**
     * error function shows an error messsage when plugwrap is not created
     * 
     * @memberof CreatePlugwrap
     */
    error = (err) => {
        message.error(err || utils.getTranslationText ('msg_plugwrap_not_created','Plugwrap not created'), 2);
    };

    /**
     * warning function shows a warning when user tries to update a plugwrap not created by him
     * 
     * @memberof CreatePlugwrap
     */
    warning = () => {
        message.warning(utils.getTranslationText ('msg_cannot_updated_the_plugwrap','You cannot update the plugwrap that is not created by you'), 2);
    }

    /**
     * handleFilter function is called when plugwrap name is typed or selected in dropdown box. It filters and
     * populates the form if the name matches with existing plugwrap
     * 
     * @memberof CreatePlugwrap
     */
    handleFilter() {
        let data = this.state.plugwrapData;
        let result = data.find(element => element.name === this.state.name);
        
        if (result) {
            this.props.form.setFieldsValue({
                manufacturer: result.manufacturer,
                wrapType: result.wrapType,
                corpor: result.corpor,
                thick: result.thick,
                weight: result.weight
            });
        }
    }

    /**
     * handleSubmit function checks if the data is valid and if so then successfully creates/updates a new plugwrap otherwise it points to the appropriate error.
     * @param {*} e here e is an event passed
     * @memberof CreatePlugwrap
     */
    handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let obj = {
                    'name': this.state.name
                };
    
                let Obj = Object.assign(obj, values);
                if(obj.name.trim()) {
                    CelaneseAPI.post(config.API.plugwrap, Obj).then((res) => {
                        if (res.error) {
                            if(res.error=== utils.getTranslationText ('msg_cant_update_plug_wrap','You cant update this plug wrap name already exists')){
                                this.warning();
                            }
                            else{
                                this.error();
                            }
                        } 
                        else {
                            this.success();
                            this.clearFields();
                            getPlugwrapData().then(res => {
                                return res;
                            })
                            this.props.handleCreatePlugwrapCancel();
                        }
                    }).catch(() => {
                        this.error();
                    });
                } else {
                    this.error(utils.getTranslationText ('msg_plugwrap_name_mandatory','Plugwrap name is mandatory'));
                }
            }
            else {
                this.error();
            }
        });
    }

    /**
     * validateTextInputFields validates the value so that it contains only numbers and alphabets.
     * @param {} rule
     * @param {String} value it is the value user types in the field
     * @param {} callback
     * @memberof CreatePlugwrap
     */
    validateTextInputFields = (rule, value, callback) => {
        var alphabets = /^[a-zA-Z0-9_]+( [a-zA-Z0-9_]+)*$/;
        if(value && value.length > 0 && !value.match(alphabets)) {
            callback(utils.getTranslationText ('msg_only_alphabets_number','You are allowed only alphabets and numbers'));
        } else {
            callback()
        }
    }

    /**
     * validateNumberInputFields validates that the field value so that it cannot be zero.
     * @param {} rule
     * @param {String} value it is the value user types in the field
     * @param {} callback
     * @memberof CreatePlugwrap
     */
    validateNumberInputFields = (rule, value, callback) => {
        if(value === 0) {
            callback(utils.getTranslationText ('err_msg_value_cannot_be_zero','Value cannot be zero'));
        }
        this.validateNonZeroNumberInputFields(rule, value, callback);
    }

    /**
     * validateNonZeroNumberInputFields validates the fields value so that it is not negative.
     * @param {} rule
     * @param {String} value it is the value user types in the field
     * @param {} callback
     * @memberof CreatePlugwrap
     */
    validateNonZeroNumberInputFields=(rule,value,callback) => {
        var numbers= /^[0-9]\d*(\.\d+)?$/;
        
        if( value < 0) {
            callback(utils.getTranslationText ('msg_value_cannot_negative','Value cannot be negative!'));
        }
        else if(value && value.length && !value.match(numbers)) {
            callback(utils.getTranslationText ('msg_plz_enter_number','Please enter a number'));
        }
        else {
            callback();
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form || '';

        return (
            <div className="createPlugwrap-container">
                <p className="createPlugwrap-container__title"><Translation labelName="lbl_create_plugwrap" defaultText="Create Plugwrap"/></p>
                <div className="createPlugwrap-container__form">
                    <Form onSubmit={(e) => this.handleSubmit(e)}>
                        <div className="createPlugwrap-container__select">
                            <label className="createPlugwrap-container__select--label"><span className="required-field-asterick">*</span><Translation labelName="lbl_name" defaultText="Name"/> : </label>
                            <Combobox
                                caseSensitive={false}
                                value={this.state.name}
                                onChange={(name) => {
                                    if(typeof name === 'string' && name.length > 30) {
                                        return;
                                    }
                                    this.setState({name}, function() {
                                        this.handleFilter()
                                    })
                                }}
                                data={(this.state.plugwrapData) ? this.state.plugwrapData.map(e => e.name) : []}
                            />
                        </div>
                        <FormItem
                            label={<Translation labelName="tbl_hdr_manifacturer" defaultText="Manufacturer"/>}>
                            {getFieldDecorator('manufacturer', {
                                rules: [{ required: false, message: <Translation labelName="err_field_cannot_be_empty" defaultText="Field cannot be empty!"/>}],
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            label={<Translation labelName="lbl_plugwrap_type" defaultText="Plugwrap Type"/>}>
                            {getFieldDecorator('wrapType', {
                                rules: [{ required: false, message: <Translation labelName="err_field_cannot_be_empty" defaultText="Field cannot be empty!"/> },
                                        {validator: this.validateTextInputFields,}],
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            label={<Translation labelName="lbl_coresta_porosity_cu" defaultText="CORESTA Porosity(CU)"/>}>
                            {getFieldDecorator('corpor', {
                                rules: [{ required: false, message: <Translation labelName="err_field_cannot_be_empty" defaultText="Field cannot be empty!"/>},
                                        { validator: this.validateNonZeroNumberInputFields,}],
                            })(
                                <InputNumber />
                            )}
                        </FormItem>
                        <FormItem
                            label={<Fragment><Translation labelName="hdr_plugwrap_tbl_hdr_thickness" defaultText="Thickness"/>(<Translation labelName="units_lbl_mm" defaultText="mm"/>)</Fragment>}>
                            {getFieldDecorator('thick', {
                                rules: [{ required: true, message: <Translation labelName="err_field_cannot_be_empty" defaultText="Field cannot be empty!"/>},
                                        { validator: this.validateNumberInputFields,}],
                            })(
                                <InputNumber />
                            )}
                        </FormItem>
                        <FormItem
                            label={<Fragment><Translation labelName="lbl_hdr_weight" defaultText="Weight"/>(<Translation labelName="units_g_m2" defaultText="g/m2"/>)</Fragment>}>
                            {getFieldDecorator('weight', {
                                rules: [{ required: false, message: <Translation labelName="err_field_cannot_be_empty" defaultText="Field cannot be empty!"/>},
                                        { validator: this.validateNumberInputFields,}],
                            })(
                                <InputNumber />
                            )}
                        </FormItem>
                        <div className="createPlugwrap-container__form-buttons">
                            <button
                                value="create"
                                type="submit"
                                className="btn btn-default"
                            ><Translation labelName="btn_create" defaultText="CREATE"/></button>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}

const DefaultCreatePlugwrap = Form.create()(CreatePlugwrap);

const mapStateToProps = ({ filtersState }) => ({
    plugwrapData: filtersState.plugwrapData
});

export default connect(mapStateToProps, null)(DefaultCreatePlugwrap);

CreatePlugwrap.propTypes = {
    handleCreatePlugwrapCancel: PropTypes.func,
    form: PropTypes.object,
    plugwrapData: PropTypes.array
};


// WEBPACK FOOTER //
// ./src/components/CreatePlugwrap/index.js